import { contractIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { ContractPage } from "../contracts/contract-page.tsx";
import { loadContract } from "../contracts/loaders.ts";
import { ContractPending } from "../contracts/pending.tsx";
import { useViewer } from "../data/hooks.ts";
import { isSectionShown, sections } from "../shell/navigation.ts";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { contractTabSchema } from "../shell/search.ts";
import { NotFoundPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/contracts/$id/{-$tab}");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id, tab } = route.useParams();
  return viewer === null || !isSectionShown(sections.contracts, viewer.role) ? (
    <NotFoundPage />
  ) : (
    <ContractPage viewer={viewer} contractId={id} tab={tab ?? "overview"} />
  );
};

export const Route = createFileRoute("/_app/contracts/$id/{-$tab}")({
  params: {
    parse: ({ id, tab }) => ({
      id: parameterOrNotFound(contractIdSchema, id),
      tab: parameterOrNotFound(contractTabSchema.exclude(["overview"]).optional(), tab),
    }),
    stringify: ({ id, tab }) => ({ id, tab }),
  },
  loader: async ({ context, params }) => loadContract(context.data, params.id),
  pendingComponent: ContractPending,
  component: Page,
});
